module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-right.9e6d7b4e.svg";